import { render } from "./ClientInventarioAlmacenes.vue?vue&type=template&id=c79b9080&scoped=true"
import script from "./ClientInventarioAlmacenes.vue?vue&type=script&lang=js"
export * from "./ClientInventarioAlmacenes.vue?vue&type=script&lang=js"

import "./ClientInventarioAlmacenes.vue?vue&type=style&index=0&id=c79b9080&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c79b9080"]])

export default __exports__